export interface SuccessStoriesState {
  successStoriesData: SuccessStories;
}

export interface SuccessStories {
  updatedId: number | null;
  isHandlingStoryChange: boolean;
  handledStorySuccessfully: boolean;
  isLoading: boolean;
  isLoadingStories: boolean;
  pageNo: number;
  pageSize: number;
  totalItems: number;
  pages: number;
  stories: Partial<SuccessStory>[];
  story: SuccessStory;
  isDeleted: boolean;
}

export interface SuccessStory {
  id?: number;
  title: string;
  short_description: string;
  business_challenges: string;
  solutions: string;
  benefits_results: string;
  post_by?: {
    oid: string;
    displayName: string;
    upn: string;
  };
  modified_by?: {
    oid: string;
    displayName: string;
    upn: string;
  };
  post_date: string;
  last_modified_by?: string;
  last_modified_date?: string;
  main_image?: string;
  cover_image: string;
  content_images: string[];
  video: string;
}
